export default __webpack_public_path__ + "static/media/sketchup.ca97c37e.jpg";